

<div class="docs-DialogExample-lgHeader warning"  >
    <div class="ms-Dialog ms-Dialog--lgHeader ms-Dialog-Notify">
      <div class="ms-Dialog-title">Cerrar Sesión</div>
      <div class="ms-Dialog-content">
        <div class="ms-Grid" dir="ltr">
          <div class="ms-Grid-row">
            <div class="ms-Grid-col ms-sm2 ms-lg2">
              <span><i class="ms-Icon ms-Icon--WarningSolid"></i></span>
            </div>
            <div class="ms-Grid-col ms-sm10 ms-lg10">
              <p class="ms-Dialog-subText ms-Dialog-subText-notify modal__notify-text">¿Desea cerrar sesión? </p>
            </div>
          </div>
        </div>
        <div class="ms-Dialog-actions">
          <app-button buttonClass="ms-Dialog-action ms-Button--primary" buttonId="btnCancel" (buttonClick)="close()" label="Cancelar"></app-button>
          <app-button buttonClass="ms-Dialog-action ms-Button--primary" buttonId="btnClose" (buttonClick)="onLogOut()" label="Cerrar Sesión"></app-button>
            <!-- <button class="ms-Button ms-Dialog-action ms-Button--primary" type="button"  (click)="close()">
                <span class="ms-Button-label">Cancelar</span> 
            </button>
            <button class="ms-Button ms-Dialog-action ms-Button--primary" type="button" (click)="onLogOut()">
              <span class="ms-Button-label">Cerrar Sesión</span> 
            </button> -->
            
          
        </div>
      </div>
      
    </div>
  </div>
  